import { GroupByMode, newTaskSuffix } from '@griply/types';
import { getNewTaskPrefill } from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';
import { DayPartSections } from 'shared/types/page-sections';

import { DayPartHeader } from '../day-part-header';
import { TreeTaskCard } from '../tree-task-card';
import { useDayPartRenderData } from './day-part-render-context';

export const DayPartRenderItem: React.FC<RenderItemProps> = ({
  item,
  itemInstance,
  tree,
  isMultiSelectModifierPressed,
}) => {
  const {
    groupSettings,
    tasksMap,
    tasks,
    today,
    denseFormat,
    defaultNewTaskDate,
  } = useDayPartRenderData();

  const type = item.type;

  if (type === TaskListItemTypes.Task) {
    const task = tasksMap[item.sourceId];
    if (!task) {
      return null;
    }

    const parentElement = itemInstance.getParent();
    const parentSectionId = parentElement?.getItemData().sourceId;
    const displayDue =
      parentSectionId === DayPartSections.Overdue
        ? undefined
        : groupSettings.displayDue;

    return (
      <TreeTaskCard
        task={task}
        tree={tree}
        item={itemInstance}
        tasks={tasks}
        isMultiSelectModifierPressed={isMultiSelectModifierPressed}
        displayDue={displayDue}
      />
    );
  }

  if (type === TaskListItemTypes.NewTask) {
    const groupSectionId = item.sourceId.replace(newTaskSuffix, '');
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.DayPart,
      groupSectionId,
      groupSetting: groupSettings,
      today,
      defaultNewTaskDate,
    });
    return (
      <NewTaskRow
        startTime={prefill.startTime ?? null}
        duration={null}
        date={prefill.startDate}
        lifeArea={prefill.lifeAreaId}
        tags={prefill.tagIds}
      />
    );
  }

  if (type === TaskListItemTypes.DayPart) {
    return <DayPartHeader denseFormat={denseFormat} item={itemInstance} />;
  }

  return null;
};
